/* shto-not-basic: the founder video. Nothing from Wistia loads with the page: the box shows a poster picture (a <button>).
   A click, or Enter / Space on it, swaps the poster for Wistia's player with autoPlay=true, so the video starts because the
   visitor asked for it (the live page's hidden copy autoplayed with sound; this replaces that). */
(function () {
  if (window.ShtoNotBasic) return;
  window.ShtoNotBasic = true;

  function play(box) {
    var id = (box.getAttribute('data-video-id') || '').trim();
    if (!/^[a-z0-9]+$/i.test(id) || box.querySelector('iframe')) return;
    var frame = document.createElement('iframe');
    frame.className = 'shto-not-basic__player';
    frame.src = 'https://fast.wistia.net/embed/iframe/' + id + '?autoPlay=true&playsinline=true&videoFoam=false&fitStrategy=contain&seo=false';
    frame.title = box.getAttribute('data-video-title') || 'Video';
    frame.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
    frame.setAttribute('allowfullscreen', '');
    frame.setAttribute('data-shto-wistia', '');
    box.classList.add('is-playing');
    box.appendChild(frame);
    var poster = box.querySelector('.shto-not-basic__poster');
    if (poster) poster.hidden = true;
    frame.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (event) {
    var poster = event.target.closest && event.target.closest('[data-shto-section="shto-not-basic"] .shto-not-basic__poster');
    if (!poster) return;
    event.preventDefault();
    play(poster.closest('[data-shto-video]'));
  });
})();
